/**
 * Asset - Represents an asset in a construction project.
 * Used to track project assets, their status, plan associations, and tracking information.
 */
export class Asset {
  /** Project identifier */
  Project_ID: number;

  /** Project name */
  Project: string;

  /** Index identifier */
  Index: string;

  /** Status of the asset */
  Status: string;

  /** Instance number */
  Instance: number;

  /** Plan identifier */
  PlanID: number;

  /** Plan decoder identifier */
  PlanDecoder: string;

  /** Indicates if the asset is being tracked */
  IsTracked: boolean;

  /** Unique asset identifier */
  AssetID: string;

  /**
   * Creates a new Asset instance
   * @param data - Object containing asset properties
   */
  constructor(data: {
    Project_ID: number;
    Project: string;
    Index: string;
    Status: string;
    Instance: number;
    PlanID: number;
    PlanDecoder: string;
    IsTracked: boolean;
    AssetID: string;
  }) {
    this.Project_ID = data.Project_ID;
    this.Project = data.Project;
    this.Index = data.Index;
    this.Status = data.Status;
    this.Instance = data.Instance;
    this.PlanID = data.PlanID;
    this.PlanDecoder = data.PlanDecoder;
    this.IsTracked = data.IsTracked;
    this.AssetID = data.AssetID;
  }

  /**
   * Creates an Asset from a plain object (useful for deserialization)
   * @param obj - Plain object with asset data
   * @returns New Asset instance
   */
  static fromObject(obj: Partial<Asset>): Asset {
    return new Asset({
      Project_ID: obj.Project_ID ?? 0,
      Project: obj.Project ?? "",
      Index: obj.Index ?? "",
      Status: obj.Status ?? "",
      Instance: obj.Instance ?? 0,
      PlanID: obj.PlanID ?? 0,
      PlanDecoder: obj.PlanDecoder ?? "",
      IsTracked: obj.IsTracked ?? false,
      AssetID: obj.AssetID ?? "",
    });
  }

  /**
   * Converts the Asset to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      Project_ID: this.Project_ID,
      Project: this.Project,
      Index: this.Index,
      Status: this.Status,
      Instance: this.Instance,
      PlanID: this.PlanID,
      PlanDecoder: this.PlanDecoder,
      IsTracked: this.IsTracked,
      AssetID: this.AssetID,
    };
  }
}


